import React, { Component } from 'react';

// Displays the available item information

/* 
    ulong OwnerId
    ulong? ItemId
    string SubscriptionKeyHash
    string Server
    string CharacterName
    Container? Container
    string Container_DynamoDb
    ItemLocation? EquippedTo
    uint? EquippedTo_DynamoDb
    uint? Index
    uint? Tab
    uint? Row
    uint? Column
    uint? WeenieId
    int? Quantity
    string TreasureType
    string Name
    string Name_Lower
    string Description
    string Description_Lower
    int? MinimumLevel
    float? Weight
    uint? Durability
    string Binding 
    string ItemType
    uint? PlatValue
    uint? GoldValue
    uint? SilverValue
    uint? CopperValue
    int? Hardness
    ItemLocation EquipsToFlags 
    List<string> EquipsTo 
    bool EffectsValid
    List<Effect> Effects
    string Proficiency
    string Proficiency_Lower
    string WeaponTypeString
    string WeaponTypeString_Lower
    string WeaponType
    string WeaponType_Lower
    string ShieldType
    string ShieldType_Lower
    string ArmorType
    string ArmorType_Lower
    string ArmorSubType
    string ArmorSubType_Lower
    string ItemSubType
    string ItemSubType_Lower
    List<string> NoUmdCheckList
*/

class Item extends Component {
    render() {
        //let { item } = this.props;
        // maybe break out the item member's into varriables so we can 
        // directly test the presence and use it with shorter names
        let { Name, Name_Lower } = this.props.item;
        
        return (
            <div>
            {Name ? <div>{Name}</div>: null}
            {Name_Lower ? <div>{Name_Lower}</div>: null}
            </div> 
        );
    };
}

export default Item;